import { formatUTCDateToLocal } from 'src/utilities';

export function formatAcknowledgedBy(
  acknowledgment:
    | {
        firstName: string;
        timestamp: string;
        lastName: string;
      }
    | undefined
) {
  if (acknowledgment && acknowledgment.firstName) {
    const acknowledgedDate = formatUTCDateToLocal(false, acknowledgment?.timestamp);
    return `${acknowledgment.firstName} ${acknowledgment.lastName}, ${acknowledgedDate}`;
  } else {
    return 'Unacknowledged';
  }
}
